import axios from '../utils/axios'
let mapApi={
    // 分页获取模拟图信息
    getMapInfo(params, success){
        axios('/map/getmap', params, success)
    },
    //新增模拟图
    addMap(params, success){
        axios('/map/addmap', params, success)
    },
    //修改模拟图
    updateMap(params, success){
        axios('/map/updatemap', params, success)
    },
     //修改模拟图
    deleteNode(params, success){
        axios('/map/deleteNode', params, success)
    },
    //删除模拟图
    deleteMap(params, success){
        axios('/map/deletemap', params, success)
    },
    //修改状态
    updateStatus(params, success){
        axios('/map/updatestatus', params, success)
    },
     //上传
    fileUpload(params, success){
        axios('/map/fileupload', params, success)
    },
     //获取图类型
    getAllMapType(params, success){
        axios('/map/getmaptype', params, success)
    },
     //新增图类型
    addMapType(params, success){
        axios('/map/addmaptype', params, success)
    },
     //修改图类型
    updateMapType(params, success){
        axios('/map/updatemaptype', params, success)
    },
     //删除图类型
    delMapType(params, success){
        axios('/map/delmaptype', params, success)
    },
     //获取线信息
    getLine(params, success){
        axios('/map/getline', params, success)
    },
     //新增线信息
    addLine(params, success){
        axios('/map/addline', params, success)
    },
     //删除线信息
    delLine(params, success){
        axios('/map/delline', params, success)
    },
}
export default mapApi


// WEBPACK FOOTER //
// ./src/api/map.js